import globalEventBus from 'toxilibs/event_bus_queued.js'
import World from '../world_core/world.js'
import './determine_the_way.js'
import './verification.js'

globalEventBus.twoWayBlock('goal world', 'sounds')
globalEventBus.twoWayBlock('goal world', 'renderer')
globalEventBus.twoWayBlock('goal world', 'user controls')
globalEventBus.twoWayBlock('goal world', 'stats')

globalEventBus.block({from: 'world',      to: 'determine the way'})
globalEventBus.block({from: 'goal world', to: 'way verifier'})
globalEventBus.block({from: 'goal world', to: 'game flow'})

let goalPlayer

//FIXME
globalEventBus('game flow').on('player updated by God', function (cell, params) {
    goalPlayer.godUpdate(params)
})


globalEventBus.on('challenge loaded', function (challenge) {
    let world = new World(globalEventBus('goal world'), challenge)
    goalPlayer = world.player

    if (challenge.code) {
        globalEventBus.emit('goal code found', challenge.code)
        globalEventBus.emit('new instructions added', challenge.code)
    }
})

